import * as React from 'react';
import { usePixabayImageSearchQuery } from '../../../../queries';
import { useMediaChooserContext } from '../context';

export function useMediaChooserSearch() {
	const inputRef = React.useRef(null);
	const { setSelectedImage, setShowSuggestions, imageSearchOptions } = useMediaChooserContext();

	const [pendingSearchTerm, setPendingSearchTerm] = React.useState<string>(null);

	const [searchTerm, setSearchTerm] = React.useState<string>(null);

	// Queries

	const {
		fetchNextPage: fetchNextImages,
		hasNextPage: hasNextImagePage,
		data: searchedImages,
		isPending,
	} = usePixabayImageSearchQuery({ searchTerm, options: imageSearchOptions });

	const onClearClicked = () => {
		setSearchTerm(null);

		setPendingSearchTerm(null);
		setShowSuggestions(true);
	};

	const onSearchTermInputChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
		e.preventDefault();

		setSearchTerm(null);
		setPendingSearchTerm(e.target.value);
	};

	const onInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			onCtaClicked();
		}
	};

	const getMoreImages = async () => {
		if (hasNextImagePage) {
			fetchNextImages();
		}
	};

	const onCtaClicked = () => {
		setSearchTerm(pendingSearchTerm);

		setSelectedImage(null);
		setShowSuggestions(false);
	};

	return {
		getMoreImages,
		inputRef,
		isLoading: isPending,
		onClearClicked,
		onCtaClicked,
		onInputKeyDown,
		onSearchTermInputChanged,
		pendingSearchTerm,
		searchedImages,
		searchTerm,
	} as const;
}
